import { motion } from "framer-motion";

const CLIP_16 = "polygon(16px 0%, calc(100% - 16px) 0%, 100% 16px, 100% calc(100% - 16px), calc(100% - 16px) 100%, 16px 100%, 0% calc(100% - 16px), 0% 16px)";
const CLIP_6  = "polygon(6px 0%, calc(100% - 6px) 0%, 100% 6px, 100% calc(100% - 6px), calc(100% - 6px) 100%, 6px 100%, 0% calc(100% - 6px), 0% 6px)";

const VARIANT = {
  profit: { border: "rgba(255,255,255,0.055)" },
  loss:   { border: "rgba(255,255,255,0.055)" },
  blue:   { border: "rgba(255,255,255,0.05)" },
  none:   { border: "rgba(255,255,255,0.045)" },
};

const PANEL_BG = "linear-gradient(180deg, rgba(22,25,32,1) 0%, rgba(17,19,24,1) 100%)";

export default function OctaPanel({
  children,
  className = "",
  glowColor = "none",
  onClick,
  animate = true,
  delay = 0,
  size = "default",
  tintColor,
  riskHighlight,
}) {
  const clipPath = size === "sm" ? CLIP_6 : CLIP_16;
  const v = VARIANT[glowColor] || VARIANT.none;
  const borderBg = riskHighlight ? `${riskHighlight}20` : v.border;

  const panel = (
    <div
      className="group"
      style={{ cursor: onClick ? "pointer" : "default" }}
      onClick={onClick}
    >
      {/* Outer shadow for depth/separation — FIX 7 */}
      <div style={{
        filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.25)) drop-shadow(0 0 1px rgba(0,0,0,0.3))",
        transition: "filter 0.3s ease, transform 0.3s ease",
      }}
      className={onClick ? "group-hover:-translate-y-[2px] group-hover:drop-shadow-lg" : ""}
      >
        {/* Border — FIX 4: brightens on hover + risk highlight */}
        <div style={{
          clipPath,
          background: borderBg,
          padding: "1px",
          transition: "background 0.8s ease",
        }}
        className={onClick ? "group-hover:bg-white/[0.08]" : ""}
        >
          {/* Glass panel surface */}
          <div
            style={{ clipPath, background: PANEL_BG, transition: "filter 0.3s ease" }}
            className={`relative overflow-hidden ${onClick ? "group-hover:brightness-[1.06]" : ""} ${className}`}
          >
            {/* Platform tint — FIX 2: subtle color identity */}
            {tintColor && (
              <div className="absolute inset-0 pointer-events-none" style={{
                background: `radial-gradient(ellipse at top left, ${tintColor}06, transparent 70%)`,
              }} />
            )}
            {/* Risk highlight glow */}
            {riskHighlight && (
              <div className="absolute inset-0 pointer-events-none" style={{
                background: `radial-gradient(ellipse at top right, ${riskHighlight}08, transparent 60%)`,
                transition: "opacity 1.5s ease",
              }} />
            )}
            {/* Top edge highlight */}
            <div className="absolute top-0 left-0 right-0 pointer-events-none" style={{
              height: "1px",
              background: "linear-gradient(90deg, transparent 10%, rgba(255,255,255,0.07) 30%, rgba(255,255,255,0.09) 50%, rgba(255,255,255,0.07) 70%, transparent 90%)",
              transition: "opacity 0.3s ease",
            }}
            className={onClick ? "group-hover:opacity-100" : ""}
            />
            {/* Inner bottom shadow */}
            <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, transparent 65%, rgba(0,0,0,0.15) 100%)",
            }} />
            {/* Content */}
            <div className="relative">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );

  if (!animate) return panel;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {panel}
    </motion.div>
  );
}
